import { Component, ViewChild } from '@angular/core';
import { CommonService } from '../../../Model/Common/common.service';
import { EmployeeConfirmationService } from '../../../Model/EmployeeConfirmation/employee-confirmation.service';
import { SessionService } from '../../../Util/Session/session.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-emp-confirmation',
  standalone: true,
  imports: [CommonModule, FormsModule, DataTablesModule, RouterModule, LoaderComponent],
  templateUrl: './emp-confirmation.component.html',
  styleUrl: './emp-confirmation.component.scss'
})
export class EmpConfirmationComponent {
  isDisabled: boolean = false;
  TableDatas = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  Filter = {
    EmpType: null as any,
  }
  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private employeeconfirmation: EmployeeConfirmationService,
    private session: SessionService,
  ) {
    this.Filter.EmpType = this.session.GetUserDetails().EmpType
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_EmployeeConfirmationDetailsSelect();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  ESS_EmployeeConfirmationDetailsSelect() {
    this.isDisabled = true;
    this.employeeconfirmation.ESS_EmployeeConfirmationDetailsSelect({ SelectType: "ALL", ESS_EmployeeConfirmationDetailsId: 0, EmpMasterId: this.session.GetUserDetails().UserId, ApprovalStatus: 'ALL' }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TableDatas = Object.values(response.Table);
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { this.isDisabled = false; },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  StatusReplace(status: String, IsTerminated: boolean) {
    return this.common.ToLowerCase(status) == 'rejected' ? IsTerminated ? 'Terminated' : 'Extended' : status;
  }
}
